import React from 'react'

const HelpContact = () => (
    <span><a target='_blank' href='https://www.bloombergindustry.com/contact-us/'>&nbsp;Bloomberg Industry Group Customer Service</a></span>
) 

export default HelpContact